import React, { useState, useEffect } from 'react';
import { Grid, Box, Button } from '@mui/material';
import { AutoComplete } from 'antd';
import { DatePicker, Space } from 'antd';
import type { DatePickerProps } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { fetchHotelCityDispatch } from '../../reducers/HotelReducer';
const Option = AutoComplete.Option;
const { RangePicker } = DatePicker;

const SearchEngineHotel = () => {
	const [departDate, setDepartDate] = useState('');
	const { busDepart, busArr } = useSelector((state) => state.ui);
	const { hotelcity } = useSelector((state) => state.hotel);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const onChangeReturn: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDateReturn(dateString);
	};
	useEffect(() => {
		let formData = {};
		dispatch(fetchHotelCityDispatch(formData));
	}, []);
	const showModal = () => {
		setOpen(true);
	};
	const handleCancel = () => {
		setOpen(false);
	};
	const handleOk = () => {
		// setLoading(true);
		setTimeout(() => {
			// setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleChange = (value) => {
		let cityData = {
			keywords: value,
			limits: 10,
		};
		dispatch(fetchHotelCityDispatch(cityData));
	};
	const opsList =
		hotelcity?.result?.length > 0 &&
		hotelcity?.result?.map((l) => {
			return (
				<Option
					value={`${l.city_name} - ${l.country_name},${l.country_code}`}>{`${l.city_name} - ${l.country_name},${l.country_code} `}</Option>
			);
		});

	const handleChange2 = (value) => {
		let cityData = {
			keywords: value,
			limits: 10,
		};
		dispatch(fetchHotelCityDispatch(cityData));
	};
	const opsList2 =
		hotelcity?.result?.length > 0 &&
		hotelcity?.result?.map((l) => {
			return (
				<Option
					value={`${l.city_name} - ${l.country_name},${l.country_code}`}>{`${l.city_name} - ${l.country_name},${l.country_code} `}</Option>
			);
		});
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const handleSubmit = () => {
		let formData = {
			departure_city: busDepart.split(' ')[0],
			arrival_city: busArr.split(' ')[0],
			sourceid: busDepart.split(',')[1],
			destinationid: busArr.split(',')[1],
			dateofjourney: departDate,
		};
		console.log('formData', formData);
		navigate('/searchresultbus', { state: formData });
	};
	return (
		<div>
			<Grid container spacing={1}>
				<Grid item xs={12} sm={12} md={3} lg={3}>
					<AutoComplete
						style={{ width: '100%' }}
						dropdownMenuStyle={{
							maxHeight: 1000,
							overflowY: 'visible',
						}}
						placeholder='Where are you going?'
						onClick={(e) => console.log('val', e.target.value)}
						onChange={handleChange}>
						{opsList}
					</AutoComplete>
				</Grid>
				{/* <Grid item xs={12} sm={12} md={3} lg={3}>
					<AutoComplete
						style={{ width: '100%' }}
						dropdownMenuStyle={{
							maxHeight: 1000,
							overflowY: 'visible',
						}}
						placeholder='To'
						onChange={handleChange2}>
						{opsList2}
					</AutoComplete>
				</Grid> */}

				<Grid item xs={12} sm={12} md={3} lg={3}>
					<RangePicker
						disabledDate={disabledDate}
						style={{ width: '100%', padding: 8 }}
						onChange={onChangeReturn}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={3} lg={3}>
					<Button
						onClick={showModal}
						style={{
							textTransform: 'capitalize',
							padding: 7,
							border: '1px solid lightgrey',
							width: '100%',
						}}>
						Traveller Class
					</Button>{' '}
					<Modal
						open={open}
						title='Travellers'
						onOk={handleOk}
						onCancel={handleCancel}
						footer={[
							<Button key='back' onClick={handleCancel}>
								OK
							</Button>,
						]}></Modal>
				</Grid>
				<Grid item xs={12} sm={12} md={3} lg={2}>
					<Button
						onClick={handleSubmit}
						variant='contained'
						style={{
							width: '100%',
							background: 'orange',
							fontWeight: 'bold',
							padding: '7px',
						}}>
						Search
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default SearchEngineHotel;
